import MaintenancePage from "./maintenance.container";

export default MaintenancePage;
